import { render, staticRenderFns } from "./CadastroCnaeUnidade.vue?vue&type=template&id=52be75a0&"
import script from "./CadastroCnaeUnidade.vue?vue&type=script&lang=js&"
export * from "./CadastroCnaeUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports